import { ActionTypes } from "../store/actionTypes";
import { getChatSendErrorMessage, isThreadBusyError } from "./apiErrorMessage";

type ChatDispatch = (action: { type: string; payload?: unknown }) => void;

/** Reset loading/thinking state; drop or mark the optimistic user message on send failure. */
export function dispatchChatSendFailure(
  dispatch: ChatDispatch,
  error: unknown,
  requestId?: string
): string {
  const message = getChatSendErrorMessage(error);
  dispatch({ type: ActionTypes.END_THINKING });
  dispatch({ type: ActionTypes.CHAT_LOADING, payload: false });
  dispatch({ type: ActionTypes.CHAT_ERROR, payload: message });
  if (requestId) {
    if (isThreadBusyError(error)) {
      dispatch({
        type: ActionTypes.REMOVE_PENDING_MESSAGE,
        payload: { request_id: requestId },
      });
    } else {
      dispatch({
        type: ActionTypes.UPDATE_MESSAGE_STATUS,
        payload: {
          request_id: requestId,
          status: "failed",
          pending: false,
        },
      });
    }
  }
  return message;
}
